import { forwardRef, useImperativeHandle } from "react"
import { parseISO } from "date-fns"
import { useUser } from "modules/users"
import { dateFormatWithTimezone } from "utils/formatTime"

import { StringDatePickerProps } from "./DatePickerProps"
import DatePicker from "."

const StringDatePicker = ({ dateFormat, ...restProps }: StringDatePickerProps, ref: any) => {
  const { Timezone } = useUser() || {}

  const formatInput = (isoString: string) => {
    try {
      if (!isoString) {
        return null
      }

      return parseISO(isoString)
    } catch (e) {
      console.log(e)
    }

    return null
  }

  const formatOutput = (value: Date) => {
    return dateFormatWithTimezone(value, Timezone, dateFormat || "yyyy-MM-dd'T'HH:mm:ssXXX")
  }

  useImperativeHandle(ref, () => ({
    focus: () => {},
  }))

  return (
    <DatePicker
      dateFormat={dateFormat || "yyyy-MM-dd"}
      formatInput={formatInput}
      formatOutput={formatOutput}
      ref={ref}
      {...restProps}
    />
  )
}

export default forwardRef(StringDatePicker)
